import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { QuestionnaireApi } from "../../Models/Api/Questionnaire";
import type { Questionnaire } from "../../Models/Domain/Questionnaire";

import camelize from "@/Utils/Camelize";

class QuestionnaireApiToQuestionnaireTransformer implements Transformer<QuestionnaireApi, Questionnaire> {
  public transform(questionnaireApi: QuestionnaireApi): Questionnaire {
    return camelize<QuestionnaireApi, Questionnaire>(
      questionnaireApi,
      ["uuid", "visible", "name", "render_url", "type", "triggers_id"],
      ["id", "isVisible"]
    ) as Questionnaire;
  }
}

export default QuestionnaireApiToQuestionnaireTransformer;
